// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__OtjQn","title":"Header_title__2Vpny","left":"Header_left__3qvwp","clinicName":"Header_clinicName__1reFQ"};